import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

class AppTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string,
    private suffix: string
  ) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`${this.prefix}${lang}${this.suffix}`);
  }
}

export function TranslateLoaderFactory(http: HttpClient) {
  const base = String(environment.apiBaseUrl.translation || '').replace(/\/$/, '');
  return new AppTranslateLoader(http, `${base}/fbi.`, `.json?q=${environment.buildNumber}`);
}
